export { sl } from '@payloadcms/translations/languages/sl'
